import { BasicCard } from 'components/BasicCard';
import useCertificateHelper from 'hooks/useCertificateHelper';

const NotProvidedValueCard = () => {
  const { defaultValue } = useCertificateHelper();

  return <BasicCard $margin="0 0 1.5rem 0">{defaultValue}</BasicCard>;
};

export default NotProvidedValueCard;
